import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getUnreadApplication } from "sr/utils/api/cleaner/getUnreadApplication";

export const fetchCleanerChat = createAsyncThunk('cleanerchat', async (params:any)=> {
    const queryParams = new URLSearchParams()
        queryParams.append('cleaner_id', params?.cleanerId)
        const res = await getUnreadApplication(queryParams)
    try {
                    if(res?.success===true) {
                   
                    return res?.data;
                    }
    }
    catch(e:any){

    }

})

interface initialState  {
    isError:Boolean,
    data:any,
    isLoading:any
}
const initialState:initialState = {
    isError:false,
    data:null,
    isLoading:false
}
const cleanerChatSlice = createSlice({
    name:'cleanerChat',
    initialState,
    extraReducers:(builder)=> {
        builder.addCase(fetchCleanerChat.pending, (state, action)=> {
            state.isLoading = true
        })
        builder.addCase(fetchCleanerChat.fulfilled, (state, action)=> {
            state.data = action.payload
        })
        builder.addCase(fetchCleanerChat.rejected, (state, action)=> {
            state.isError = true
        })
    },
    reducers:{
        updateUnreadChatCount:(state, action)=> {
            const payloadJobId = action?.payload?.job_id?._id;
            const unreadData = state?.data || [];
            const newjob = unreadData?.some((item) => {
                const itemJobId = item?.job_id?._id;
                return itemJobId === payloadJobId;
            });

            if (!newjob) {
                state.data = [...unreadData, action.payload];
            }
        },
        removeUnreadChatCount:(state, action)=> {
            const payloadJobId = action?.payload?.job_id?._id || action?.payload?.job_id;
            const unreadData = state?.data || [];
            state.data = unreadData.filter((item) => item?.job_id?._id !== payloadJobId);
        }
    },
})
export default cleanerChatSlice.reducer;
export const {updateUnreadChatCount, removeUnreadChatCount} = cleanerChatSlice.actions
